@if (isMobile()) {
	<!-- Backdrop -->
	<div 
		class="tw-fixed tw-inset-0 tw-z-[9999] tw-bg-black/40 tw-backdrop-blur-sm tw-transition-opacity tw-duration-300 tw-ease-in-out"
		[class.tw-opacity-100]="isOpen()"
		[class.tw-opacity-0]="!isOpen()"
		[class.tw-pointer-events-none]="!isOpen()"
		(click)="dismissPrompt()"
		aria-hidden="true">
	</div>

	<!-- Prompt Sheet -->
	<aside 
		class="tw-fixed tw-inset-x-0 tw-bottom-0 tw-z-[10000] tw-bg-white tw-rounded-t-3xl tw-transform tw-transition-transform tw-duration-300 tw-ease-[cubic-bezier(0.16,1,0.3,1)] tw-shadow-[0_-10px_40px_rgba(0,0,0,0.12)]"
		[class.tw-translate-y-0]="isOpen()"
		[class.tw-translate-y-full]="!isOpen()"
		[class.tw-pointer-events-none]="!isOpen()"
		[inert]="!isOpen()"
		aria-labelledby="prompt-title"
		role="dialog"
	>
		<div class="tw-max-w-md tw-mx-auto tw-px-4 tw-pb-6 tw-pt-6">
			<header class="tw-mb-8 tw-text-center">
				<h2 id="prompt-title" class="tw-font-medium tw-mb-0 tw-text-brand-blue tw-text-xl tw-text-start tw-tracking-tight">
					Musaffa looks better in the app ✨
				</h2>
			</header>

			<div class="tw-grid tw-gap-4">
				<div class="tw-flex tw-items-center tw-justify-between tw-w-full tw-gap-3">
					<div class="tw-flex tw-items-center tw-gap-2">
						<img ngSrc="/assets/images/logoMark.svg" width="36" height="36" alt="Musaffa App Icon">
						<h3 class="tw-mb-0 tw-text-base/snug tw-font-medium">Musaffa App</h3>
					</div>
					<button 
						class="tw-bg-brand-green tw-border-0 tw-text-sm tw-px-5 tw-py-2 tw-text-white tw-rounded-lg tw-w-28"
						(click)="redirectToAppStore()">
						Download
					</button>
				</div>
				<div class="tw-flex tw-items-center tw-justify-between tw-w-full tw-gap-3">
					<div class="tw-flex tw-items-center tw-gap-2">
						<span class="tw-w-9 tw-h-9 tw-flex tw-items-center tw-justify-center tw-text-gray-950 tw-bg-gray-100 tw-rounded-full">
							<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
								<g fill="none" stroke="currentColor" stroke-width="1.5">
									<circle cx="12" cy="12" r="10"/>
									<path stroke-linejoin="round" d="M8 12c0 6 4 10 4 10s4-4 4-10-4-10-4-10-4 4-4 10Z"/>
									<path stroke-linecap="round" stroke-linejoin="round" d="M21 15H3m18-6H3"/>
								</g>
							 </svg>
						</span>
						<h3 class="tw-mb-0 tw-text-base/snug tw-font-medium">Continue in browser</h3>
					</div>
					<button 
						class="tw-bg-brand-green/10 tw-border-0 tw-text-sm tw-px-5 tw-py-2 tw-text-black tw-rounded-lg tw-w-28"
						(click)="dismissPrompt()">
						Continue
					</button>
				</div>
			</div>
		</div>
	</aside>
}